import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { Store } from "@ngrx/store";
import { EMPTY, mergeMap, Observable, of, take } from "rxjs";

import { CustomerInfoDTO } from "@guest-web/api";
import { IAppCommonState, UpdateCustomer } from "@guest-web/core";
import { ignoreNil } from "@triparound/trp-components/shared";

import { AuthenticationFacadeService } from "../../authentication/authentication-facade.service";
import { LayoutFacadeService } from "../components/layout/layout-facade.service";
import { CustomerFacadeService } from "../services/customer-facade.service";
import { InitializationService } from "../services/initialization.service";
import { NavigationFacadeService } from "../services/navigation-facade.service";

export const loadCustomerResolver: ResolveFn<Observable<CustomerInfoDTO>> = (
	route: ActivatedRouteSnapshot,
) => {
	const customerFacade = inject(CustomerFacadeService);
	const initializationService = inject(InitializationService);
	const customerUuid = customerFacade.customerInfo?.uuid || null;
	const routeCustomerUuid = route.params["customerUuid"];
	const isSameUser = customerUuid === routeCustomerUuid || false;
	const navigationFacade = inject(NavigationFacadeService);
	const authenticationFacade = inject(AuthenticationFacadeService);
	const store = inject(Store<IAppCommonState>);
	const layoutFacade = inject(LayoutFacadeService);

	layoutFacade.toggleAppLoader(true);

	if (isSameUser) {
		return customerFacade.customerInfo$;
	}
	initializationService.loadCustomerInfo(routeCustomerUuid);
	return customerFacade.customerInfo$.pipe(
		ignoreNil(),
		take(1),
		mergeMap(customer => {
			if (customer && Object.keys(customer).length > 0) {
				const userCached = authenticationFacade.getUserData();
				// Update customer info with acctkn and acid
				const updatedCustomer = {
					...customer,
					acctkn: userCached?.acctkn || null,
					acid: userCached?.acid || null,
					profileEuros: userCached?.profileEuros || null,
				};
				store.dispatch(new UpdateCustomer(updatedCustomer));
				return of(updatedCustomer);
			}
			layoutFacade.toggleAppLoader(false);
			navigationFacade.go({ path: ["/"] });
			return EMPTY;
		}),
	);
};
